import { Box } from '@wishket/design-system';
import { use } from 'react';

import NewLandingArticleItem from '../NewLandingArticle/NewLandingArticleItem';

import { NewLandingArticleItemProps } from '@/shared/types';
interface RecentContentsProps {
  recentContentsPromise: Promise<NewLandingArticleItemProps[]>;
}

const RecentContents = ({ recentContentsPromise }: RecentContentsProps) => {
  const recentContents = use(recentContentsPromise);

  return (
    <Box
      className="grid grid-cols-1 gap-5 tablet:grid-cols-2"
      data-testid="landing-recent-contents"
    >
      {recentContents.map((content, index) => (
        <Box
          className="rounded-3xl border border-w-gray-100 p-5 pb-4 desktop:p-6 desktop:pb-5"
          key={index}
          data-testid={`landing-recent-content-${index}`}
        >
          <NewLandingArticleItem {...content} />
        </Box>
      ))}
    </Box>
  );
};

export default RecentContents;
